import { useState } from 'react';
import { feedItems, feedTabs } from '@/mocks/homeData';

export default function Feed() {
  const [active, setActive] = useState('全部');
  const items = active === '全部' ? feedItems : feedItems.filter((it) => it.category === active);

  return (
    <section id="feed" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col justify-between gap-5 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-primary-600">
              <i className="ri-newspaper-fill" /> 内容大全
            </span>
            <h2 className="mt-2 text-2xl font-extrabold text-foreground-950 md:text-4xl">
              91免费内容大全 · 最新更新流
            </h2>
          </div>

          <div className="inline-flex items-center gap-1 self-start rounded-full border border-background-200 bg-background-50 p-1 md:self-auto">
            {feedTabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActive(tab)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  active === tab
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:bg-secondary-100'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {items.map((item) => (
            <a
              key={item.id}
              href="#top"
              className="group flex flex-col justify-between rounded-2xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300"
            >
              <div>
                <span className="inline-flex whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-700">
                  {item.category}
                </span>
                <h3 className="mt-3 text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-base">
                  {item.title}
                </h3>
              </div>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span>{item.time}</span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line" /> {item.views}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}